module.exports = __webpack_public_path__ + "static/media/bookmark1.208da9f7.png";